import React from 'react';

interface SeasonInputProps {
  label: string;
  value: string;
  onChange: (val: string) => void;
  onBlur?: () => void;
  startDate?: string;
  endDate?: string;
  required?: boolean;
  error?: string | null;
  disabled?: boolean;
}

export function SeasonInput({
  label,
  value,
  onChange,
  onBlur,
  required,
  error,
  disabled = false,
}: SeasonInputProps) {
  // Validate format: S## or W##
  const isValidFormat = value ? /^[SW]\d{2}$/.test(value) : true;
  const hasError = error && error.trim() !== '';

  const handleChange = (newValue: string) => {
    // Filter to only allow S, W, and digits
    const filtered = newValue.toUpperCase().replace(/[^SW0-9]/g, '').slice(0, 3);
    onChange(filtered);
  };

  return (
    <div className="block mb-2">
      {/* Label */}
      <label className="block mb-1.5 text-base font-semibold text-gray-600">
        {label}
        {required && <span className="text-danger-500 ml-1">*</span>}
      </label>

      {/* Input field */}
      <input
        type="text"
        value={value}
        onChange={e => handleChange(e.target.value)}
        onBlur={onBlur}
        placeholder="S26 or W26"
        maxLength={3}
        disabled={disabled}
        className={`w-full px-3 py-2.5 border rounded-lg text-gray-900 text-lg outline-none transition-all font-mono
          ${disabled ? 'bg-gray-50 cursor-not-allowed' : 'bg-white'}
          ${hasError
            ? 'border-danger-500 focus:border-danger-500 focus:ring-3 focus:ring-danger-500/10'
            : 'border-gray-300 focus:border-primary-500 focus:ring-3 focus:ring-primary-500/10'
          }`}
      />
    </div>
  );
}
